export default __webpack_public_path__ + "static/media/55_1_1.f135a1c9.png";